"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkmark = exports.upTriangle = exports.downTriangle = exports.zeroWidthSpace = void 0;
exports.zeroWidthSpace = "\u200B";
exports.downTriangle = "\u25BC";
exports.upTriangle = "\u25B2";
exports.checkmark = "\u2713";
